/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Button, Input, Modal, TableProps } from 'antd';
import TableComponent from '../table';
import { IGeography } from '@/interfaces/geography';
import { searchGeography } from '@/utils/geographyUtils';

interface IProps {
  open: boolean;
  handleOk: (item: IGeography, locale: 'th' | 'en') => void;
  handleCancel: () => void;
}

const GeographySelectorModal = ({ open, handleOk, handleCancel }: IProps) => {
  const [criteria, setCriteria] = useState<string>('');

  const columns: TableProps<IGeography>['columns'] = [
    {
      title: 'ตำบล',
      dataIndex: 'subdistrictNameTh',
      key: 'subdistrictNameTh',
      className: 'font-medium',
      render: (_, rec) => (
        <div className="flex flex-col">
          <div>{_}</div>
          <div className="text-gray-500">{rec.subdistrictNameEn}</div>
        </div>
      ),
    },
    {
      title: 'อำเภอ',
      dataIndex: 'districtNameTh',
      key: 'districtNameTh',
      className: 'font-medium',
      render: (_, rec) => (
        <div className="flex flex-col">
          <div>{_}</div>
          <div className="text-gray-500">{rec.districtNameEn}</div>
        </div>
      ),
    },
    {
      title: 'จังหวัด',
      dataIndex: 'provinceNameTh',
      key: 'provinceNameTh',
      className: 'font-medium',
      render: (_, rec) => (
        <div className="flex flex-col">
          <div>{_}</div>
          <div className="text-gray-500">{rec.provinceNameEn}</div>
        </div>
      ),
    },
    {
      title: 'รหัสไปรษณีย์',
      dataIndex: 'postalCode',
      key: 'postalCode',
      className: 'font-medium',
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      className: 'font-medium',
      align: 'center',
      fixed: 'right',
      width: 60,
      render: (_, rec) => (
        <div className="flex flex-col gap-1">
          <Button
            type="primary"
            size="small"
            onClick={() => handleOk(rec, 'th')}
          >
            ไทย
          </Button>
          <Button
            ghost
            type="primary"
            size="small"
            onClick={() => handleOk(rec, 'en')}
          >
            Eng
          </Button>
        </div>
      ),
    },
  ];

  const data = searchGeography(criteria);

  return (
    <Modal
      title="ค้นหาที่อยู่"
      open={open}
      width={'1200px'}
      onCancel={handleCancel}
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
      ]}
    >
      <div className="flex flex-col gap-3 w-full">
        <Input.Search
          className="md:max-w-[400px] md:min-w-[400px]"
          placeholder="ค้นหา"
          allowClear
          size="large"
          enterButton="ค้นหา"
          onSearch={search => setCriteria(search)}
        />
        <TableComponent<IGeography>
          columns={columns}
          criteria={{}}
          data={{ data, totalRecords: 0 }}
          loading={false}
          onTableChange={() => console.log()}
          showPagination={false}
          scrollLength={600}
          scrollYLength={500}
        />
      </div>
    </Modal>
  );
};

export default GeographySelectorModal;
